import type {PermissionType} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import {checkPermissionAccessByDataScope, usePermissionsParsedQuery} from '@hproduce/permissions'
import React from 'react'
import {Outlet, Navigate} from 'react-router'

import {checkIfMultiplePermissionsGranted} from '../shared/permissions'

import {getUrl} from './helpers'
import {ROUTES} from './router'

interface PermissionGuardedRouteProps {
  requiredPermissions: [type: PermissionType, ...types: PermissionType[]]
  operator?: 'AND' | 'OR'
}

export const PermissionGuardedRoute: React.FC<PermissionGuardedRouteProps> = ({
  requiredPermissions,
  operator = 'AND'
}) => {
  const {data: permissions} = usePermissionsParsedQuery(requiredPermissions)
  const {plantId: plantCode} = useUpmPlantContext()
  const {country: countryId} = useUpmPlantContext()

  const isAccessGranted = permissions
    ? checkIfMultiplePermissionsGranted({
        requiredPermissionTypes: requiredPermissions,
        permissions,
        testFn: (permission) =>
          checkPermissionAccessByDataScope(countryId, plantCode, permission.parsedDataScope),
        operator
      })
    : false

  if (!isAccessGranted) {
    return <Navigate to={getUrl(ROUTES.BASE.NOT_AUTHORIZED.path, {})} replace />
  }
  return <Outlet />
}
